var render, staticRenderFns
import script from "./collapse-toggle.vue?vue&type=script&lang=js&"
export * from "./collapse-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbe0a110')) {
      api.createRecord('cbe0a110', component.options)
    } else {
      api.reload('cbe0a110', component.options)
    }
    
  }
}
component.options.__file = "src/js/components/collapse-toggle.vue"
export default component.exports